import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

class Top {
  constructor() {
    this.elShowUp();
  }

  elShowUp() {
    const logo = document.querySelector('.fv__logo');
    const item = document.querySelector('.fv__item');
    const conceptArea = document.querySelector('.concept');
    const conceptCatch = document.querySelector('.concept__catch');
    const conceptTxt = document.querySelector('.concept__txt');

    // FVのロゴとプロダクトの出現
    const TL = gsap.timeline();
    TL.to(logo, { y: 0, autoAlpha: 1, duration: 0.3 }, '0.5').to(item, {
      scale: 1,
      autoAlpha: 1,
      duration: 1,
    });

    // コンセプトのテキスト要素の出現
    gsap.from(conceptCatch, {
      y: -20,
      autoAlpha: 0,
      duration: 0.5,
      ease: 'power2.inOut',
      scrollTrigger: {
        trigger: conceptArea,
        start: 'top-=10% top',
        end: 'bottom bottom',
      },
    });

    gsap.from(conceptTxt, {
      y: -20,
      autoAlpha: 0,
      duration: 0.5,
      ease: 'power2.inOut',
      scrollTrigger: {
        trigger: conceptArea,
        start: 'top-=5% top',
        end: 'bottom bottom',
      },
    });
  }
}
export default Top;
